import { Brain } from "lucide-react";

/**
 * Twin-learned supplier quick-pick chips. Tapping one starts a Manual Entry
 * pre-filled with that supplier.
 */
export default function SupplierQuickPick({ suppliers = [], onPick }) {
  if (!suppliers.length) return null;
  return (
    <section data-testid="supplier-quick-pick">
      <div className="text-[10px] uppercase tracking-[0.2em] font-heading text-white/40 mb-2 flex items-center gap-1.5">
        <Brain className="w-3 h-3 text-[#34D399]" />
        Twin quick-pick
      </div>
      {/* Chips wrap into as few rows as they can — smaller padding and
          text so a long supplier name doesn't grab a whole row on its
          own the way `h-9 text-sm` did before. */}
      <div className="flex flex-wrap gap-1.5">
        {suppliers.map((s) => (
          <button
            key={s}
            type="button"
            data-testid={`quick-supplier-${s}`}
            onClick={() => onPick?.(s)}
            className="py-2 px-3 rounded-full bi-surface text-[12px] leading-none text-white/90 hover:brightness-110 hover:border-[#FF9500]/40 active:scale-95 transition"
          >
            {s}
          </button>
        ))}
      </div>
    </section>
  );
}
